export const FraudAnalysisStatus = {
	UNKNOWN: { id: 0, name: "Unknown" },
	ACCEPT: { id: 1, name: "Accept" },
	REJECT: { id: 2, name: "Reject" },
	REVIEW: { id: 3, name: "Review" },
	ABORTED: { id: 4, name: "Aborted" },
	UNFINISHED: { id: 5, name: "Unfinished" },
};



// WEBPACK FOOTER //
// ./src/enums/FraudAnalysisStatus.js